import React from "react";

const Washing_15 = React.forwardRef(
  ({ width = "41", height = "28", viewBox = "0 0 41 28", fill = "none", className }, ref) => {
    return (
      <svg
        ref={ref}
        {...{ width, height, viewBox, fill, className }}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.5643 9.76255L20.1429 0L25.7314 9.77975L39.2795 2.02586L40.3054 3.74901L26.7262 11.5207L31.1705 19.2982L40.2883 24.5339L39.2592 26.2554L33.1372 22.74L36.1429 28H4.14294L7.16114 22.7182L1.02583 26.2295L0 24.5064L9.12284 19.2852L13.5694 11.5037L0.016932 3.72152L1.04602 2L14.5643 9.76255ZM15.3542 12.5285L12.6452 17.2693L18.1367 14.1263L15.3542 12.5285ZM10.6834 20.7023L7.6985 25.9259H32.5874L29.6092 20.7142L20.1517 15.2834L10.6834 20.7023ZM27.6425 17.2723L24.94 12.5429L22.1686 14.1291L27.6425 17.2723ZM23.9452 10.802L20.1536 12.972L16.3491 10.7874L20.1429 4.14815L23.9452 10.802Z"
          fill="black"
        />
      </svg>
    );
  },
);

export default Washing_15;
